export const USER_STATUS_DND = 'do_not_disturb';
export const USER_STATUS_AVAILABLE = 'available';
export const USER_STATUS_AVAILABLE_FOR_COLLEAGUES = 'available_for_colleagues';
export const USER_STATUS_OFFLINE = 'offline';
